import { CdkDrag, CdkDropList } from "@angular/cdk/drag-drop";
import { InjectionToken, Provider } from "@angular/core";
import { DragAndDropService } from "./drag-and-drop.service";

export interface DropListRegistryItem {
    connectedDropLists: CdkDropList[];
}

export type DropListRegistry = Map<string, DropListRegistryItem>;

export interface OutOfBoundsStrategy {
    handleOutOfBounds(drag?: CdkDrag<unknown>, originDropList?: CdkDropList<unknown>, activeDropList?: CdkDropList<unknown>): void;
    handleReturnInBounds(): void;
    handleDragEnd(): void;
}

export interface DragAndDropConfig {
    outOfBoundsStrategy?: OutOfBoundsStrategy; // Placeholder behavior when dragging out of bounds
    proximityThreshold?: number; // Distance in pixels to consider "near" for out-of-bounds detection
}

export const DRAG_AND_DROP_CONFIG = new InjectionToken<DragAndDropConfig>("DRAG_AND_DROP_CONFIG");

export function provideDragAndDrop(config?: DragAndDropConfig): Provider[] {
    return [{ provide: DRAG_AND_DROP_CONFIG, useValue: config || {} }, DragAndDropService];
}
